<template>
  <div>
    <!-- <div data-v-a0ce7e36="" data-v-249f9abc="" class="main-footer">
      <div data-v-a0ce7e36="" style="clear: both;"></div>
      <div data-v-a0ce7e36="" class="inner">
        <div data-v-a0ce7e36="" class="left-footer">
          <div data-v-a0ce7e36="" class="code-inner clearfix">
            <dl data-v-a0ce7e36="" v-for="(item,index) in gongzhong" :key="index">
              <dt data-v-a0ce7e36="">{{item.title}}</dt>
              <dd data-v-a0ce7e36="" class="mt10"><img data-v-a0ce7e36="" :src="item.img" alt=""></dd>
            </dl>
          </div>
          <div data-v-a0ce7e36="" class="mt20">{{ guanfang.title }}</div> <img data-v-a0ce7e36="" :src="guanfang.img" alt="" class="mt10">
        </div>
        <div v-if="companyInfo.links.length" data-v-a0ce7e36="" class="center-footer">
          <h3 data-v-a0ce7e36="">友情链接</h3>
          <ul data-v-a0ce7e36=""  class="list">
            <li data-v-a0ce7e36="" v-for="(item,index) in Links" :key=index><a data-v-a0ce7e36="" href="https://www.sz-water.com.cn/" target="href">{{ item }}</a></li>
          </ul>
        </div>
        <div data-v-a0ce7e36="" class="right-footer"><img data-v-a0ce7e36="" src="img/beian.7642251.png" alt="" class="mt20"></div>
      </div>
      <div data-v-a0ce7e36=""></div>
    </div> -->
    <div style="background:#eee" data-v-61fc6ca3="" data-v-249f9abc="" class="bottom">
      <div style="width:1200px;margin:0 auto;display:flex;justify-content:space-around;">
        <p data-v-61fc6ca3="" v-if="companyInfo.tel">服务热线：{{companyInfo.tel}} E-mail:</p>
        <p data-v-61fc6ca3="" v-if="companyInfo.title">Copyright © {{companyInfo.title}}</p>
        <p data-v-61fc6ca3="" v-if="companyInfo.recordNumber">{{companyInfo.recordNumber}}</p>
        <p data-v-61fc6ca3="" v-if="companyInfo.ICP"><a data-v-61fc6ca3="" href="https://beian.miit.gov.cn/" target="_blank">{{companyInfo.ICP}}</a></p>
      </div>
      
    </div>
  </div>
</template>
<script>
// import axios from "axios";
// 引入http
import http from "../http/index";
import companyInfo from "../config";
export default{
  data() {
    return {
      companyInfo,
      gongzhong: [
        {
          "title":"微信公众号",
          "img":"img/public-code.9a50a9f.png"
        },
        {
          "title":"祁县APP",
          "img":"img/yingyeting.png"
        },
        {
          "title":"小程序",
          "img":"img/xiaochengxu.jpg"
        }
      ],
      guanfang:{
        title:"官方微博",
        img:"img/weibo.a6da410.png"
      },
      Links:[
          "祁县水务有限公司",
          "中国水星网",
          "祁县水务科技有限公司"
      ]
    }
  },
  methods:{
    async getlist(){
      try {
        const res = await http.getlist();
        console.log("155548778596649864", res);
      } catch (ex) {
        console.log(ex);
      }
    }
  },
  mounted() {
    this.getlist()
  }
}
</script>
<style>
.mt10 img{
  width: 90px;
  height: 90px;
}
.bottom{
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>